<div class="top-section">
    <h3>
        User List
    </h3>
</div>

<section class="rate-request rate-request-sec">
    <div class="middle-section">
        <div class="container">
            <div class="rate-request-form">
                <div class="rate-request-form-inner">
                    <div class="request-btn">
                        <input type="text" class="form-control" pInputText size="50" placeholder="Search"
                            (change)="filterSearch($event.target.value)">
                        <div class="btn-search"><button class="btn  btn-go my-2 my-sm-0" type="submit"><img
                                    src="../../../assets/images/Group 103.svg"></button></div>
                    </div>
                </div>
                <div class="table-responsive rate-request-tbl">

                    <p-table [value]="userData">

                        <ng-template pTemplate="header">
                            <tr>
                                <th>User Name</th>
                                <th>Email Id</th>
                                <th>Company</th>
                                <th>Registration Date</th>
                                <th>Plan Name</th>
                                <th>No Of Quotation</th>
                                <th>Account Verification</th>
                                <th>Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-user>
                            <tr>
                                <td>{{ user.userName }}</td>
                                <td>{{ user.emailId }}</td>
                                <td>{{ user.companyName }}</td>
                                <td>{{ user.registerDate | date: "dd-MM-yyyy" }}</td>
                                <td>{{ user.planName }}</td>
                                <td>{{ user.noOfQuotations }}</td>
                                <td *ngIf="user.emailConfirmed == true">verified</td>
                                <td *ngIf="user.emailConfirmed != true"> Not verified</td>
                                <td>
                                    <a class="action-btn " tooltipPosition="top" pTooltip="Edit User"
                                        data-toggle="modal" data-target=".view-userpopup"
                                        (click)="openEditUserModal(user.userId)">
                                        <i class="fa fa-edit"></i>
                                    </a>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <p-paginator *ngIf="totalcount > 0" [rows]="requestVM.pageSize" [rowsPerPageOptions]="[5,10,20]"
                    [totalRecords]="totalcount" (onPageChange)="paginate($event)"></p-paginator>
                <div *ngIf="totalcount == 0">
                    <span>No records found</span>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Edit UserList PopUp -->
<ng-template #editUserModal let-modal>
  <div class="modal-header">
    <h3>Edit User</h3>
    <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
      <span class="pi pi-fw pi-times"></span>
    </button>
  </div>
  <form [formGroup]="UsersForm" (ngSubmit)="UpdateUser()">
    <div class="modal-body">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-md-4 form-group">
            <label class="custom-labal "> User Name </label>
            <input type="text" class="form-control" formControlName="UserName" readonly />
          </div>
          <div class="col-md-4 form-group">
            <label class="custom-labal "> Email Id </label>
            <input type="text" class="form-control" formControlName="EmailId" [attr.disabled]="true" />
          </div>
        </div>
        <div class="row pt-3">
          <div class="col-md-4 form-group">
            <label class="custom-labal "> Membership Status </label>
            <div class="pRel">
              <p-dropdown [options]="planlist" optionLabel="planName" formControlName="planId" class="select-dropdown-sec" placeholder="" [virtualScroll]="true" [itemSize]="31" [(ngModel)]="selectedplan" [filter]="false"></p-dropdown>
              <span class="downArrow">
                <img src="../../../../../assets/images/arrow.png" />
              </span>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="custom-labal "> Having Admin Rights </label>
            <p-inputSwitch formControlName="IsAdministrator" [(ngModel)]="hasAdminRight"></p-inputSwitch>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 form-group">
            <label class="custom-labal "> Upgrade Methods </label>
            <div class="pRel">
              <p-dropdown [options]="upgradeMethods" [virtualScroll]="true" [itemSize]="31" optionLabel="Value" formControlName="upgradeId" class="select-dropdown-sec" placeholder="Select upgrade methods" [(ngModel)]="selectedMethod" [filter]="false" (onChange)="upgradeMethod($event)"></p-dropdown>
              <span class="downArrow">
                <img src="../../../../../assets/images/arrow.png" />
              </span>
            </div>
          </div>
          <div class="col-md-4 form-group" *ngIf="isManual">
            <label class="custom-labal "> Expiry Date </label>
            <div class="pRel">
              <p-calendar formControlName="expiryDate" [readonlyInput]="true" showIcon="true" showButtonBar="true" placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}" icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy"></p-calendar>
            </div>
          </div>
        </div>
        <!-- Will implement later -->
        <!-- <div class="row"><div class="col-md-4 form-group"><label class="custom-labal ">
                                        Max Request Allowed
                                    </label><input type="number" class="form-control" formControlName="maxRequestAllowed" /></div><div class="col-md-4 form-group"><label class="custom-labal ">
                                        Request Exhausted
                                    </label><input type="number" class="form-control" formControlName="requestExhausted" readonly/></div></div><div class="row"><div class="col-md-4 form-group"><label class="custom-labal ">
                                        Start Date
                                    </label><div class="pRel"><p-calendar formControlName="startDate" [readonlyInput]="true" showIcon="true" showButtonBar="true"
                                          placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}"
                                          icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy"></p-calendar></div></div><div class="col-md-4 form-group"><label class="custom-labal ">
                                        End Date
                                    </label><div class="pRel"><p-calendar formControlName="endDate" [readonlyInput]="true" showIcon="true" showButtonBar="true"
                                          placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}"
                                          icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy"></p-calendar></div></div></div><div class="row"><div class="col-md-4 form-group"><label class="custom-labal ">
                                        API Key
                                    </label><input type="text" class="form-control" formControlName="apiKey" readonly/></div></div> -->
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-signIn">Update</button>
    </div>
  </form>
</ng-template>